<template>
  <div>
    <div class="row">
      <div class="col">
        <router-link to="/" class="link-back">
          <MaterialSvg
            class="icon-white"
            name="keyboard_backspace"
            :width="24"
          />
          {{ $t('detail.back') }}
        </router-link>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-sm-12 col-lg-8">
        <h3 class="mb-5">{{ $t('contact.contactform') }}</h3>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="selectSubject">{{ $t('contact.subject') }}</label>
            <select
              class="form-control form-select"
              id="selectSubject"
              aria-label="Select subject"
              v-model="subject"
            >
              <option value="My scent cartridge is empty!">
                {{ $t('contact.cartridge-empty') }}
              </option>
              <option value="My scent cartridge leakes!">
                {{ $t('contact.cartridge-leaks') }}
              </option>
              <option value="My scent device doesn't work properly.">
                {{ $t('contact.device-not-working') }}
              </option>
              <option value="My scent device can't connect.">
                {{ $t('contact.device-not-connecting') }}
              </option>
              <option value="I need help with my Scent intensity.">
                {{ $t('contact.scent-intensity') }}
              </option>
              <option value="I need help deciding what scent to choose.">
                {{ $t('contact.scent-choice') }}
              </option>
              <option value="Please give me a call.">
                {{ $t('contact.call') }}
              </option>
              <option value="Other">
                {{ $t('contact.other') }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label" for="message">{{ $t('contact.message') }}</label>
            <textarea
              class="form-control"
              id="message"
              cols="30"
              rows="10"
              v-model.trim="message"
              @blur="validateMessage"
              :class="{ 'form-error': messageValidity === 'invalid' }"
            ></textarea>
            <Message
              v-if="messageValidity === 'invalid'"
              :message="$t('error.form-message-empty')"
              type="danger"
            />
          </div>
          <Message
            v-if="send"
            :message="$t('error.form-message-received')"
            type="info"
          />
          <Message
            v-if="failed"
            :message="$t('error.form-not-submitted')"
            type="danger"
          />
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary btn-block"
              @click="validateMessage"
            >
              {{ $t('button.submit') }}
            </button>
          </div>
          <div class="form-group d-md-none">
            <a href="tel:+310134600112" class="btn btn-primary btn-block"
              >{{ $t('contact.call-sense-company') }}</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Action as SupportAction } from "@/store/support/types";

export default {
  name: "Contact",
  props: {
    question: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      subject: this.$t('contact.cartridge-empty'),
      message: "",
      messageValidity: "pending",
      send: false,
      failed: false,
    };
  },
  mounted() {
    if (this.question === "scent-choice") {
      this.subject = this.$t('contact.scent-choice');
    }
  },
  methods: {
    validateMessage() {
      if (this.message === "") {
        this.messageValidity = "invalid";
      } else {
        this.messageValidity = "valid";
      }
    },
    /**
     * Send the message to the portal.
     */
    submitForm() {
      if (this.messageValidity === "valid") {
        this.$store
          .dispatch(`${SupportAction.SEND_TICKET}`, {
            title: this.subject,
            message: this.message,
          })
          .then(() => {
            this.send = true;
            this.failed = false;
            this.subject = this.$t('contact.cartridge-empty');
            this.message = "";
          })
          .catch(() => {
            this.failed = true;
          });
      }
    },
  },
};
</script>